import { Grid, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import PageConfig, { PageContext } from "../../../config";
// import { useTranslation } from "react-i18next";
import sortBy from "lodash/sortBy";
import { isEmpty } from "lodash";

const { CHECKOUT_OPTION_ENUM, PAYMENT_METHOD_ERROR } = PageConfig;

const generatePaymentMethodCSSClass = ({
  method,
  secondaryPaymentMethod,
  formErrors,
}) => {
  const fieldError = formErrors.secondaryPaymentMethod;
  if (fieldError === PAYMENT_METHOD_ERROR.REQUIRED) {
    return "error";
  }
  return method.id === secondaryPaymentMethod.id ? "selected" : "";
};

const generateLabelName = ({ method }) => {
  switch (method.id) {
    case "local_cc":
      return "sri lankan payment gateway";
    case "foreign_cc":
      return "international payment gateway";
    default:
      return method.name ?? "";
  }
};

const PaymentMethodOption = ({ method }) => {
  // const { t } = useTranslation();
  const { secondaryPaymentMethod, setSecondaryPaymentMethod, formErrors } =
    useContext(PageContext);

  const customCSSClass = generatePaymentMethodCSSClass({
    method,
    secondaryPaymentMethod,
    formErrors,
  });
  const labelName = generateLabelName({ method });

  const handleOnClick = (event) => {
    event.preventDefault();
    setSecondaryPaymentMethod(method);
  };

  return (
    <Grid
      container
      direction="column"
      className={`method-option-horizontal ${customCSSClass}`}
      onClick={handleOnClick}
    >
      <img src={method.icon} alt="payment-option" className="icon" />
      <Typography className="label">{labelName}</Typography>
    </Grid>
  );
};

const CardPaymentMethodSelector = () => {
  const { genericPaymentMethods, paymentLinkData } = useContext(PageContext);

  const supportedMethodsV2 = React.useMemo(() => {
    const residentCountry =
      paymentLinkData.post?.personalInfo?.residentCountry ?? {};
    const configedSupportedMethods =
      CHECKOUT_OPTION_ENUM.online_payment.supportedMethodsV2;
    let output = genericPaymentMethods.filter((current) => {
      if (!Object.keys(configedSupportedMethods).includes(current.id)) {
        return false;
      }
      const localConfig = configedSupportedMethods[current.id];
      const allowedOnlyContries = localConfig.allowedOnlyContries ?? [];
      const isAllowedkByResidentCountry =
        isEmpty(allowedOnlyContries) ||
        allowedOnlyContries.includes(residentCountry.code);

      return isAllowedkByResidentCountry;
    });
    output = sortBy(output, ["sortOrder"]);
    return output;
  }, [genericPaymentMethods, paymentLinkData]);

  return (
    <Grid container direction="column" className="payment-method-selector">
      {supportedMethodsV2.map((paymentMethod) => (
        <Grid item key={paymentMethod.id}>
          <PaymentMethodOption method={paymentMethod} />
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(CardPaymentMethodSelector);
